import {
    QUESTIONNAIRE_CURRENT_REQUEST,
    QUESTIONNAIRE_CURRENT_SUCCESS,
    QUESTIONNAIRE_CURRENT_FAIL,
    QUESTIONNAIRE_CURRENT_RESET,
    QUESTIONNAIRE_SAVE_ANSWER_REQUEST,
    QUESTIONNAIRE_SAVE_ANSWER_SUCCESS,
    QUESTIONNAIRE_SAVE_ANSWER_FAIL,
    QUESTIONNAIRE_SAVE_ANSWER_RESET,
    QUESTIONNAIRE_COMPLETE_REQUEST,
    QUESTIONNAIRE_COMPLETE_SUCCESS,
    QUESTIONNAIRE_COMPLETE_FAIL,
    QUESTIONNAIRE_COMPLETE_RESET,
    QUESTIONNAIRE_CHECK_ACCESS_REQUEST,
    QUESTIONNAIRE_CHECK_ACCESS_SUCCESS,
    QUESTIONNAIRE_CHECK_ACCESS_FAIL,
} from '../constants/questionnaireConstants';

export const questionnaireCurrentReducer = (state = {}, action) => {
    switch (action.type) {
        case QUESTIONNAIRE_CURRENT_REQUEST:
            return { loading: true };
        case QUESTIONNAIRE_CURRENT_SUCCESS:
            return { loading: false, questionnaire: action.payload };
        case QUESTIONNAIRE_CURRENT_FAIL:
            return { loading: false, error: action.payload };
        case QUESTIONNAIRE_CURRENT_RESET:
            return {};
        default:
            return state;
    }
};

export const questionnaireSaveAnswerReducer = (state = {}, action) => {
    switch (action.type) {
        case QUESTIONNAIRE_SAVE_ANSWER_REQUEST:
            return { loading: true };
        case QUESTIONNAIRE_SAVE_ANSWER_SUCCESS:
            return { loading: false, success: true, data: action.payload };
        case QUESTIONNAIRE_SAVE_ANSWER_FAIL:
            return { loading: false, error: action.payload };
        case QUESTIONNAIRE_SAVE_ANSWER_RESET:
            return {};
        default:
            return state;
    }
};

export const questionnaireCompleteReducer = (state = {}, action) => {
    switch (action.type) {
        case QUESTIONNAIRE_COMPLETE_REQUEST:
            return { loading: true };
        case QUESTIONNAIRE_COMPLETE_SUCCESS:
            return { loading: false, success: true, result: action.payload };
        case QUESTIONNAIRE_COMPLETE_FAIL:
            return { loading: false, error: action.payload };
        case QUESTIONNAIRE_COMPLETE_RESET:
            return {};
        default:
            return state;
    }
};

export const questionnaireCheckAccessReducer = (state = {}, action) => {
    switch (action.type) {
        case QUESTIONNAIRE_CHECK_ACCESS_REQUEST:
            return { loading: true };
        case QUESTIONNAIRE_CHECK_ACCESS_SUCCESS:
            return { loading: false, accessInfo: action.payload };
        case QUESTIONNAIRE_CHECK_ACCESS_FAIL:
            return { loading: false, error: action.payload };
        default:
            return state;
    }
};